export default __webpack_public_path__ + "static/media/health-article-icon.1e420276.svg";